import { WorkOrderDynamicAttributeName } from 'src/models/work-order-dynamic-attribute';
import * as Yup from 'yup';

export function useValidationSchema() {
  return Yup.object<WorkOrderDynamicAttributeName>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    displayName: Yup.string().nullable(),
  }) as Yup.Schema<WorkOrderDynamicAttributeName>;
}
